module.exports = __webpack_public_path__ + "static/BigLogoWhite-9074767ce189879f1e5ed7a48cedbdab.svg";